import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

// Import all template images
import ConvergenceImg from "../Assets/template/convergenceTemplate.png";
import CISImg from "../Assets/template/cisTemplate.png";
import NISImg from "../Assets/template/nisTemplate.png"; // ✅ Correct path

function Template() {
  const navigate = useNavigate();

  const templates = [
    {
      label: "Convergence Template",
      path: "/convergenceTemplate",
      img: ConvergenceImg,
      eventDetail: { item: "ConvergenceTemplate" },
    },
    {
      label: "CIS Template",
      path: "/cisTemplate",
      img: CISImg,
      eventDetail: { item: "CISTemplate" },
    },
    {
      label: "NIS Template", // ✅ New NIS Template
      path: "/nisTemplate",  // ✅ Navigate to NISTemplate
      img: NISImg,           // ✅ Use correct image
      eventDetail: { item: "NISTemplate" },
    },
  ];

  return (
    <Container>
      <Title>
        <TitleHeading>
          Available
          <span>Templates</span>
        </TitleHeading>
      </Title>
      <CardGrid>
        {templates.map((tpl, index) => (
          <Card key={index} onClick={() => navigate(tpl.path)}>
            <Thumbnail src={tpl.img} alt={tpl.label} />
            <CardLabel>{tpl.label}</CardLabel>
          </Card>
        ))}
      </CardGrid>
    </Container>
  );
}

export default Template;

// Styled Components (responsive)
const Container = styled.div`
  --template-bg: #e7f2ec;
  padding: clamp(22px, 5vw, 48px);
  width: 100%;
  max-width: none;
  margin: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: clamp(22px, 4.5vw, 44px);
  position: relative;
  background: var(--template-bg);
  border-radius: 32px;
  border: 1px solid #d7e8de;
  box-shadow: none;
  overflow: hidden;

  @media (max-width: 992px) {
    min-height: 100vh;
  }

  @media (max-width: 768px) {
    padding: clamp(18px, 6vw, 32px) clamp(14px, 6vw, 28px);
    gap: clamp(18px, 5vw, 32px);
  }

  @media (max-width: 480px) {
    padding: 16px 12px 24px;
    min-height: auto;
  }
`;

const Title = styled.header`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: clamp(6px, 2.5vw, 14px);
  margin: 0;
  text-align: center;
  color: #0f2713;
  letter-spacing: 0.3px;
`;

const TitleHeading = styled.h1`
  margin: 0;
  font-size: clamp(26px, 6.5vw, 38px);
  line-height: 1.08;
  font-weight: 800;
  text-transform: uppercase;
  color: #0f2713;
  display: flex;
  flex-direction: column;
  gap: clamp(4px, 1.8vw, 8px);
  align-items: center;
  text-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);

  span {
    font-size: clamp(24px, 6vw, 36px);
    font-weight: inherit;
    opacity: 0.92;
  }

  @media (max-width: 540px) {
    font-size: clamp(24px, 7vw, 32px);

    span {
      font-size: clamp(22px, 7vw, 30px);
    }
  }
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: clamp(16px, 3vw, 28px);
  justify-items: center;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }

  @media (max-width: 540px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

const Card = styled.div`
  background: #e7f2ec;
  border-radius: 24px;
  box-shadow: 0 12px 24px rgba(33, 70, 47, 0.14);
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 380px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #d7e8de;
  position: relative;

  &:hover {
    transform: translateY(-12px) scale(1.016);
    box-shadow: 0 18px 32px rgba(33, 70, 47, 0.2);
    border-color: #c5dfd1;
  }

  @media (max-width: 768px) {
    max-width: 340px;
  }

  @media (max-width: 480px) {
    max-width: 100%;
    border-radius: 16px;
  }
`;

const Thumbnail = styled.img`
  width: 100%;
  height: clamp(160px, 24vw, 220px);
  object-fit: cover;
  border-radius: 22px 22px 0 0;
  filter: saturate(1.04) contrast(1.04);

  @media (max-width: 480px) {
    border-radius: 20px 20px 0 0;
  }
`;

const CardLabel = styled.div`
  padding: 16px;
  font-size: clamp(16px, 3.5vw, 20px);
  font-weight: 700;
  text-align: center;
  color: #0f2713;
  letter-spacing: 0.6px;
  text-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  background: #e7f2ec;

  @media (max-width: 480px) {
    padding: 16px 12px 18px;
  }
`;